import React, { FC } from 'react';

export type Svg = {
  width?: string | number;
  height?: string | number;
  color?: string;
  rotation?: number;
  viewBox?: string;
  fill?: string;
};

export type WrapperSvg = Svg & {
  children: React.ReactNode;
  testId: string;
};

const SVGWrapper: FC<WrapperSvg> = (props: WrapperSvg) => {
  const { width, height, children, testId, viewBox = '0 0 100 100', fill } = props;
  return (
    <svg data-testid={`icon-${testId}`} xmlns="http://www.w3.org/2000/svg" width={width} height={height || width} viewBox={viewBox} fill={fill}>
      {children}
    </svg>
  );
};

export default SVGWrapper;
